import { Component, Input } from '@angular/core';
import { Customer } from '../../models';
import { KeyValuePairComponent } from '../general/key-value-pair/key-value-pair.component';
import { NgSwitch, NgSwitchCase, NgIf, NgSwitchDefault } from '@angular/common';

@Component({
  selector: 'app-integration-relationship-info',
  templateUrl: './integration-relationship-info.component.html',
  standalone: true,
  imports: [
    NgSwitch,
    NgSwitchCase,
    NgIf,
    KeyValuePairComponent,
    NgSwitchDefault
  ]
})
export class IntegrationRelationshipInfoComponent {
  @Input() set customer(value: Customer) {
    if (!value) {
      this.type = null;
      return;
    }
    this.type = 'customer';
    this.sageId = value.sage_customer_id ?? null;
    this.xeroId = value.xero_id ?? null;
    this.zohoId = value.zoho_contact_id ?? null;
    this.intactId = value.intact_customer_id ?? null;
  }

  type: 'customer' | 'invoice' | null;
  xeroId: string;
  sageId: string;
  zohoId: string;
  intactId: string;
}
